import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import {
  Wrapper,
  Heading,
  Message,
  Button,
  ImageWrapper
} from './CheckoutErrorMessageStyledComponents'
import CashoutError from '../../../assets/images/cashout_error.png'

const messagesSwitch = checkoutError => {
  switch (checkoutError.type) {
    case 'INSTRUMENT_DECLINED': {
      return (
        <React.Fragment>
          <Heading>
            <FormattedMessage id='checkoutError.insufficientFunds' />
          </Heading>
          <Message>
            <FormattedMessage id='checkoutError.insufficientFundsDescription' />
          </Message>
        </React.Fragment>
      )
    }
    case 'PAYER_CANNOT_PAY': {
      return (
        <React.Fragment>
          <Heading>
            <FormattedMessage id='checkoutError.payerCannotPay' />
          </Heading>
          <Message>
            <FormattedMessage id='checkoutError.payerCannotPayDescription' />
          </Message>
        </React.Fragment>
      )
    }
    default: {
      return (
        <React.Fragment>
          <Heading>
            <FormattedMessage id='checkoutError.error' />
          </Heading>
          <Message>
            <FormattedMessage id='checkoutError.description' />
          </Message>
        </React.Fragment>
      )
    }
  }
}

const PaypalErrorMessage = React.memo(({ checkoutError, toggleModal }) => (
  <Wrapper>
    <ImageWrapper>
      <img src={CashoutError} alt='' />
    </ImageWrapper>
    {messagesSwitch(checkoutError)}
    <Button color='primary' onClick={() => toggleModal()}>
      <FormattedMessage id='checkoutError.goBackToStore' />
    </Button>
  </Wrapper>
))

PaypalErrorMessage.displayName = 'PaypalErrorMessage'

PaypalErrorMessage.propTypes = {
  checkoutError: PropTypes.any,
  toggleModal: PropTypes.func
}

export default PaypalErrorMessage
